var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    [
      _vm.loaded
        ? _c(
            "field",
            {
              staticClass: "pb-2",
              attrs: {
                label: "Document Type",
                "error-text": _vm.showValidations
                  ? _vm.validations.packageDocumentTypeId
                  : "",
              },
            },
            [
              _c("dropdown-field", {
                attrs: {
                  source: _vm.documentTypeSource,
                  "text-field": "name",
                  "value-field": "id",
                  placeholder: "Select Document Type",
                  searchable: "",
                  debounce: "500",
                },
                model: {
                  value: _vm.updatePackageDocument.packageDocumentTypeId,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.updatePackageDocument,
                      "packageDocumentTypeId",
                      $$v
                    )
                  },
                  expression: "updatePackageDocument.packageDocumentTypeId",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "field",
            { staticClass: "pb-2", attrs: { label: "Document Tag" } },
            [
              _c("text-field", {
                model: {
                  value: _vm.updatePackageDocument.documentTag,
                  callback: function ($$v) {
                    _vm.$set(_vm.updatePackageDocument, "documentTag", $$v)
                  },
                  expression: "updatePackageDocument.documentTag",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Update")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }